<script>
    let className = '';
    export { className as class };
</script>

<img src="/logo_3.svg" alt="Critikid Logo" class="h-auto aspect-[256/102] {className} object-contain" />
